/**
 * Tab Aprovadores — histórico das aprovações da análise que gerou o projeto.
 */

import React, { useEffect, useState } from 'react';
import { aprovacoesAPI } from '../../../services/inovacaoAPI';

const COR = { pendente: '#f39c12', aprovada: '#27ae60', rejeitada: '#e74c3c', expirada: '#95a5a6' };

export default function AprovadoresWS({ projeto }) {
  const [aprovacoes, setAprovacoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    aprovacoesAPI.listarAprovacoes(projeto.analise_id)
      .then(setAprovacoes).catch(() => {}).finally(() => setLoading(false));
  }, [projeto.analise_id]);

  if (loading) return <div style={cardStyle}>Carregando…</div>;

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>
        Histórico de aprovações ({aprovacoes.length})
      </h3>
      {aprovacoes.length === 0 ? (
        <p style={{ color: '#bdc3c7' }}>Esta análise não passou pelo fluxo de aprovação.</p>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {aprovacoes.map((a) => (
            <div key={a.id} style={{
              padding: 16, background: '#f8f9fa', borderRadius: 8,
              borderLeft: `4px solid ${COR[a.estado]}`,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <b style={{ color: '#2c3e50' }}>{a.aprovador?.nome}</b>
                  <span style={{ color: '#7f8c8d' }}> · {a.papel_descricao}</span>
                  {a.obrigatorio && <span style={{ color: '#e67e22', fontSize: '0.75rem', marginLeft: 6 }}>obrigatório</span>}
                </div>
                <span style={{
                  background: COR[a.estado], color: '#fff', padding: '2px 10px',
                  borderRadius: 10, fontSize: '0.75rem',
                }}>{a.estado}</span>
              </div>
              <div style={{ marginTop: 6, color: '#7f8c8d', fontSize: '0.8rem' }}>
                Enviado: {new Date(a.recebido_em).toLocaleString('pt-BR')}
                {a.respondido_em && <>&nbsp;·&nbsp;Respondido: {new Date(a.respondido_em).toLocaleString('pt-BR')}</>}
                {a.lembretes_enviados > 0 && <>&nbsp;·&nbsp;{a.lembretes_enviados} lembrete(s)</>}
              </div>
              {a.comentario && (
                <div style={{ marginTop: 8, padding: 8, background: '#fff', borderRadius: 4,
                              fontSize: '0.85rem', color: '#555', fontStyle: 'italic' }}>
                  "{a.comentario}"
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 24,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
